<template>
  <VeterinaireForgetPassword />
</template>

<script>
  import VeterinaireForgetPassword from "@/components/VeterinaireForgetPassword.vue";
  export default {
    name: "VeterinaireForgetPasswordPage",
    components: {
      VeterinaireForgetPassword,
    },
  };
</script>
